// extracted by mini-css-extract-plugin
module.exports = {"showLessIcon":"ToggleMore_showLessIcon__6VAHT","btnWrapper":"ToggleMore_btnWrapper___93nt","start":"ToggleMore_start__ib0nQ","center":"ToggleMore_center__6XH5U"};